import { useContext } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { ThemeContext } from './Context';
import { lightTheme, darkTheme } from '../theme/muiTheme';

// Ce wrapper ne sera utilisé que pour les composants app et core
export function AppThemeWrapper({ children }) {
  const { theme } = useContext(ThemeContext);
  const currentTheme = theme === 'dark' ? darkTheme : lightTheme;

  // Toujours rendre un ThemeProvider pour éviter les remounts lors du switch
  return (
    <ThemeProvider theme={currentTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}